<template>
  <v-dialog :value="isModalActive" max-width="500" persistent @input="inputModal">
    <v-card
      id="upgrade-complete-modal-card"
      class="px-4 pt-8 pb-5"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
    >
      <v-card-text class="py-0 my-0 px-2">
        <h1>
          {{ displayOnlyFirstName }},
          {{ completePlan ? $t(`views.common.upgradeCompleteModal.${completePlan}.title`) : '' }}
        </h1>
        <div class="my-4">
          <v-icon color="primary" size="60">
            {{ getPlanIcon() }}
          </v-icon>
        </div>
        <div class="my-4">
          {{ completePlan ? $t(`views.common.upgradeCompleteModal.${completePlan}.text`) : '' }}
          <a href="mailto:hello@filios.app">hello@filios.app.</a>
        </div>

        <v-btn color="primary" class="mt-2" @click="closeAndUpdateUser">
          {{ $t('common.continue') }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import modalMixin from '@/views/components/core/modalMixin.js'
import userMixin from '@/views/components/core/userMixin.js'
import BillingMixin from '@/views/components/account/BillingMixin.js'

export default {
  mixins: [modalMixin, BillingMixin, userMixin],
  props: {
    completePlan: {
      type: String,
      default: null,
    },
  },
  methods: {
    resetForm() {},
    closeAndUpdateUser() {
      this.closeModal()
      this.$emit('updateUser')
    },
    getPlanIcon() {
      if (this.completePlan === 'custom') return 'mdi-domain'
      else if (this.completePlan === 'premium') return 'mdi-rocket'
      else if (this.completePlan === 'pro') return 'mdi-rocket-launch'
      else if (this.completePlan === 'unlimited') return 'mdi-earth'
    },
  },
}
</script>

<style lang="scss">
#upgrade-complete-modal-card {
  text-align: center;
  h1 {
    font-size: 25px;
    font-weight: 300;
  }
  a {
    text-decoration: none;
  }
}
</style>
